<template>
  <div>
    <hr />
    <div class="row-1" v-if="configInputs != 1">
      <div>
        <label class="col-form-label font-weight-bold">
          Código do Produto
        </label>
        <input
          v-model="setCodProduto"
          v-maska="['##.###.######.##-##', '']"
          :class="[
            'form-control p-3',
            { error: v$.setCodProduto.$error && listaOficial.length == 0 },
          ]"
          placeholder="Digite o código"
        />

        <div
          class="text-red"
          v-if="v$.setCodProduto.$error && listaOficial.length == 0"
        >
          O campo Descrição é obrigatório.
        </div>
        <div class="text-red" v-if="validationProduct === true">
          Código do Produto não encontrado no Sap.
        </div>

        <datalist id="mylist">
          <div v-for="l in lista_pro" :key="l.id">
            <option :value="l.cp">
              {{ l.p }}
            </option>
          </div>
        </datalist>
      </div>

      <div class="m-40">
        <label class="col-form-label font-weight-bold"> Produto </label>
        <input
          v-model="Produto.Desc"
          type="text"
          class="form-control p-3"
          placeholder="Produto"
          disabled
        />
      </div>
    </div>

    <div class="row-1" v-if="configInputs != 1">
      <div class="m-20">
        <label class="col-form-label font-weight-bold">
          Código da Matéria-Prima:
        </label>
        <input
          v-model="setCodMateriaPrima"
          list="mylistMP"
          v-maska="['#.#.##.##.#####', '']"
          :class="[
            'form-control p-3',
            { error: v$.setCodMateriaPrima.$error && listaOficial.length == 0 },
          ]"
          placeholder="Dgite o código"
        />

        <div
          class="text-red"
          v-if="v$.setCodMateriaPrima.$error && listaOficial.length == 0"
        >
          O campo Descrição é obrigatório.
        </div>
        <div class="text-red" v-if="validationFeedstock === true">
          Código da Matéria-Prima não encontrada no Sap.
        </div>

        <datalist id="mylistMP">
          <div v-for="l in lista_mp" :key="l.id">
            <option :value="l.cmp">
              {{ l.desc }}
            </option>
          </div>
        </datalist>
      </div>

      <div class="m-40">
        <label class="col-form-label font-weight-bold"> Matéria Prima </label>
        <input
          :type="tipo"
          v-model="MateriaPrima.Desc"
          class="form-control p-3"
          disabled
        />
      </div>
      <div class="btn-produto">
        <button
          @click.prevent="addProduto"
          class="btn btn-success font-weight-bold btn-button-produto"
        >
          <i class="fas fa-plus"></i>
          Adicionar
        </button>
      </div>
    </div>

    <div class="row-1">
      <!-- <TableProdutoAndMateria :lista="lista" /> -->
      <div class="tableHistorico">
        <table cellpadding="0" cellspacing="0">
          <thead>
            <tr>
              <th>Código do Produto</th>
              <th>Produto</th>
              <th>Código Materia Prima</th>
              <th>Materia Prima</th>
              <td v-if="configInputs != 1">Opção</td>
            </tr>
          </thead>
          <tbody v-for="l in listaOficial" :key="l.idp">
            <tr>
              <td style="display: none"></td>
              <td data-title="Código  Produto">{{ l.cp }}</td>
              <td data-title="Produto">{{ l.p }}</td>

              <td data-title="Código Matéria Prima">{{ l.cmp }}</td>
              <td data-title="Matéria Prima">{{ l.mp }}</td>

              <td v-if="configInputs != 1" class="btnDelete">
                <button @click="excluir(l.idpm)" type="button">Excluir</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { sap } from "../../../../../../http";
import InputI1E from "../../../../../Inputs-defaults/Inp-1-emit.vue";
import InputI1 from "../../../../../Inputs-defaults/Inp-1.vue";
import InputDataList from "../../../../../Inputs-defaults/Inp-Datalist-emit.vue";
import TableProdutoAndMateria from "../../../../../Tables/TableProdutoAndMateria.vue";
export default {
  components: { InputI1E, InputDataList, InputI1, TableProdutoAndMateria },
  props: {
    configInputs: Number,
  },
  async created() {
    // materiaprima.data.results.map((item, index) => {
    //   this.lista_mp.push({
    //     id: index,
    //     cmp: item.ItemCode,
    //     desc: item.ItemName
    //   })
    // })
    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
      this.$store.commit("MutationSetDataProdutosUpdate", this.listaOficial);
    }
    // this.$store.commit("SetLoading", false); // Tira o loading
  },
  data() {
    return {
      validationFeedstock: false,
      validationProduct: false,
      v$: useVuelidate(),
      listaOficial: [],
      getProduto: Object,
      getMateriaPrima: Object,
      setCodMateriaPrima: "",
      setCodProduto: "",
      contProAndMat: 0,
      Produto: {
        Cod: "",
        Desc: "",
      },
      MateriaPrima: {
        Cod: "",
        Desc: "",
      },

      //  Lista de Produto
      lista_pro: [],

      // Lista de Materia Prima
      lista_mp: [],
    };
  },

  validations() {
    return {
      setCodProduto: {
        // required,
        // minLength: minLength(4),
      },
      setCodMateriaPrima: {
        // required,
        // minLength: minLength(4),
      },
    };
  },

  methods: {
    async mapProduct(product) {
      this.$store.commit("SetLoading", true); // insere o loading
      if (product.trim() === "") {
        this.validationProduct = false;
        this.$store.commit("SetLoading", false);
        return;
      }

      // Ok
      const { data: productOne } = await sap.get(`/cod_product`, {
        params: {
          unidade: "MAO",
          cod_product: product,
        },
      });

      if (!productOne) {
        this.$store.commit("SetLoading", false);
        //  this.lista_pro = []
        this.Produto.Desc = "";
        this.validationProduct = true;
        return;
      }
      //  this.lista_pro.push({
      //     id: 1,
      //     cp: productOne.data.result.Code,
      //     p: productOne.data.result.Name,
      //     cmp: 200
      //   });

      this.Produto.Cod = productOne.codigo_produto;
      this.Produto.Desc = productOne.descricao_produto;
      this.validationProduct = false;
      this.$store.commit("SetLoading", false);
    },
    async mapFeedstock(feedstock) {
      this.$store.commit("SetLoading", true); // insere o loading
      if (feedstock.trim() === "") {
        this.validationFeedstock = false;
        this.$store.commit("SetLoading", false);
        return;
      }

      const { data: feedstockOne } = await sap.get(`/raw-material`, {
        params: {
          unidade: "MAO",
          material_code: feedstock,
        },
      });

      if (!feedstockOne) {
        this.$store.commit("SetLoading", false);
        //  this.lista_mp = []
        this.MateriaPrima.Desc = "";
        this.validationFeedstock = true;
        return;
      }
      //  this.lista_mp.push({
      //     id: 1,
      //     cmp: feedstockOne.data.results.ItemCode,
      //     desc: feedstockOne.data.results.ItemName
      //   });
      this.MateriaPrima.Cod = feedstockOne.results[0].itemCode;
      this.MateriaPrima.Desc = feedstockOne.results[0].itemName;
      this.validationFeedstock = false;
      this.$store.commit("SetLoading", false);
    },
    async addProduto() {
      const lista = {
        idpm: (this.contProAndMat += 1),
        idp: this.getProduto.id,
        cp: this.Produto.Cod,
        m: this.getProduto.m,
        p: this.Produto.Desc,
        idmp: this.getMateriaPrima.id,
        cmp: this.MateriaPrima.Cod,
        mp: this.MateriaPrima.Desc,
      };
      if (!this.Produto.Cod || !this.MateriaPrima.Cod) {
        const isFormCorrect = await this.v$.$validate();
        return isFormCorrect;
      } else {
        this.listaOficial.push(lista);
        this.$emit("sendListaDeProdutos", this.listaOficial);
        this.$store.commit("MutationSetDataProdutosUpdate", this.listaOficial);
        this.setCodProduto = "";
        this.setCodMateriaPrima = "";
        this.Produto.Cod = "";
        this.Produto.Desc = "";
        this.MateriaPrima.Cod = "";
        this.MateriaPrima.Desc = "";
      }
    },
    excluir(id) {
      const index = this.listaOficial.findIndex(
        (element) => element.idpm === id
      );

      this.listaOficial.splice(index, 1);
      this.$emit("sendListaDeProdutos", this.listaOficial);
      this.$store.commit("MutationSetDataProdutosUpdate", this.listaOficial);
    },

    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;

      if (dataQuery.Produtos) {
        dataQuery.Produtos.map((element, index) => {
          this.listaOficial.push({
            idpm: index,
            id_pm_update: element.ID,
            idp: element.ID,
            cp: element.COD_PRODUTO,
            p: element.DESC_PRODUTO,
            idmp: element.ID,
            cmp: element.COD_MATERIA_PRIMA,
            mp: element.DESC_MATERIA_PRIMA,
          });

          this.contProAndMat = index;
        });
      }
    },
  },
  watch: {
    "setCodProduto": async function (newValue) {
        if (newValue && newValue.trim() !== "") {
        this.loadingdescproduct = "Carregando...";
        this.validationProduct = false;
        
        try {
          const { data: productOne } = await sap.get(`/cod_product`, {
            params: {
              unidade: "MAO",
              cod_product: newValue,
            },
          });

          // Se encontrado, atualiza os dados do produto
          if (productOne && productOne.descricao_produto){
            this.Produto.Cod = productOne.codigo_produto;
            this.Produto.Desc = productOne.descricao_produto;
            this.validationProduct = false;
          }
            
        } catch (error) {
          console.error("Erro ao buscar o produto:", error);
          this.loadingdescproduct = ""
          this.Produto.Desc = "";
          this.validationProduct = true;
        }
      }
    },
    "setCodMateriaPrima": async function (newValue) {

      if (newValue && newValue.trim() !== "") {
        this.validationFeedstock = false;
        this.loadingdescfeedstock = "Carregando ..."

      try {
            const { data: feedstockOne } = await sap.get(`/raw-material`, {
              params: {
                unidade: "MAO",
                material_code: newValue,
              },
            });

            if (feedstockOne && feedstockOne.results[0].itemName) {
              this.MateriaPrima.Cod = feedstockOne.results[0].itemCode;
              this.MateriaPrima.Desc = feedstockOne.results[0].itemName;
              this.validationFeedstock = false;
            }

          } catch (error){
            console.error("Erro ao buscar a matéria prima:", error);
            this.MateriaPrima.Desc = "";
            this.validationFeedstock = true;
            this.loadingdescfeedstock = "";
          } 
        }},
}

  // watch: {
  //   setCodProduto(newValue) {
  //     let produto = this.lista_pro.find((produto) => produto.cp === newValue);
  //     if (produto) {
  //       this.Produto.Desc = produto.p;
  //       this.getProduto = produto;
  //     } else {
  //       this.Produto.Desc = "";
  //     }
  //   },
  //   setCodMateriaPrima(newValue) {
  //     let materiaprima = this.lista_mp.find(
  //       (materiaprima) => materiaprima.cmp === newValue
  //     );
  //     if (materiaprima) {
  //       this.MateriaPrima.Desc = materiaprima.desc;
  //       this.getMateriaPrima = materiaprima;
  //     } else {
  //       this.MateriaPrima.Desc = "";
  //     }
  //   },
  // },
};
</script>

<style scoped>
.btn-button-produto {
  height: 2.7rem;
  cursor: pointer;
}

.btn-produto {
  width: 20%;
  display: flex;
  justify-items: flex-end;
  align-items: end;
}

.m-40 {
  /* background: red; */
  width: 40%;
}

.m-20 {
  width: 33%;
}

.row-1 {
  display: flex;
  gap: 20px;
  margin-bottom: 10px;
}

.col-form-label {
  font-size: 0.8rem;
}

.btn-success {
  width: 100%;
  display: flex;
  align-items: center;
}

.tableHistorico {
  padding: 0;
}

.tableHistorico th {
  font-size: 0.8rem;
}

.tableHistorico .btnDelete button {
  width: 100%;
  background-color: var(--red);
  padding: 0.5rem 1rem;
  border: none;
  color: var(--white);
  border-radius: 0.5rem;
  font-weight: 700;
}

.error {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--inputColor);
  background: var(--redTransparent);
  background-clip: padding-box;
  border: 1px solid var(--greyBtn);
  border-radius: 0.35rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.text-red {
  color: var(--redTransparent);
  font-size: 12px;
  margin-top: 2px;
}

@media (max-width: 1024px) {
  .btn-produto {
    width: 25%;
  }
}

@media (max-width: 768px) {
  .row-1 {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .row-1 div {
    width: 100%;
  }

  .tableHistorico thead {
    display: none;
  }

  .tableHistorico table {
    border-radius: 10px 10px 0 0;
  }

  .tableHistorico td {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.8rem;
  }

  .tableHistorico td:nth-child(2) {
    background-color: var(--cinza);
  }

  .tableHistorico td:first-of-type {
    font-weight: bold;
    font-size: 1.2rem;
    text-align: center;
    display: flex;
    justify-content: center;
  }

  .tableHistorico td:not(:first-of-type):before {
    content: attr(data-title);
    display: block;
    font-weight: bold;
  }
}
</style>
